// src/stone/icons/CashRound.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CashRound = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 33 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "square",
          strokeMiterlimit: 10,
          strokeWidth: 2,
          d: "M16.5 30.666c8.1 0 14.667-6.566 14.667-14.666S24.601 1.333 16.501 1.333 1.834 7.9 1.834 16 8.4 30.666 16.501 30.666ZM16.5 6.666v18.667"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "square",
          strokeMiterlimit: 10,
          strokeWidth: 2,
          d: "M21.001 9.625c-2.161-1.188-8.969-2.075-8.969 2.017 0 4.899 8.645 3.17 8.645 7.492 0 4.323-5.618 3.997-9.509 2.593"
        }
      )
    ]
  }
);
var CashRound_default = CashRound;

export {
  CashRound_default
};
